<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="29"
    height="32"
    viewBox="0 0 29 32"
  >
    <defs>
      <path
        id="ruo7a"
        d="M1345.5 239a5.7 5.7 0 0 1-5.79-5.63 5.7 5.7 0 0 1 5.8-5.62 5.7 5.7 0 0 1 5.79 5.63 5.7 5.7 0 0 1-5.8 5.62zm9.64-5.63a9.52 9.52 0 0 0-9.64-9.37 9.52 9.52 0 0 0-9.64 9.38c0 2.85 1.3 5.4 3.37 7.12a13.07 13.07 0 0 0-7.23 11.63 1.9 1.9 0 0 0 1.93 1.87 1.9 1.9 0 0 0 1.93-1.88 9.52 9.52 0 0 1 9.64-9.37c5.32 0 9.64 4.2 9.64 9.38a1.9 1.9 0 0 0 1.93 1.87 1.9 1.9 0 0 0 1.93-1.88c0-5.04-2.93-9.43-7.23-11.62a9.25 9.25 0 0 0 3.37-7.13z"
      />
    </defs>
    <g>
      <g transform="translate(-1331 -223)">
        <use fill="#363636" xlink:href="#ruo7a" />
        <use fill="#fff" fill-opacity="0" stroke="#fff" stroke-miterlimit="50" stroke-width="2" xlink:href="#ruo7a" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'TheUserIcon',
};
</script>
